/* eslint-disable react-hooks/exhaustive-deps */
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Tabs, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { SupervisorSelectModal } from "../../components/modal/SupervisorSelectModal";
import { seriesProps } from "../../components/StackedLine";
import { DataAnaylseContent } from "./DataAnaylseContent";
import styles from "./HealthPrisonAnaylse.module.css";
import { getDataAnaylseData } from "./HealthPrisonAnaylseSilce";
import { Skeleton } from "./Skeleton";
const { TabPane } = Tabs;

export const DataAnaylse = () => {
  const [time, setTime] = useState(2);

  const [selectData, setSelectData] = useState<any>([]);

  const [legendList, setLegendList] = useState<any>([]);

  const [seriesList, setSeriesList] = useState<seriesProps[]>();

  const [type, setType] = useState("1");

  const [isModalVisible, setIsModalVisible] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(
      getDataAnaylseData({
        dType: Number(type),
        scope: time,
        osIds:
          selectData
            .map((v: any) => {
              return v.osId;
            })
            .join(",") || "",
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setLegendList(
          selectData.map((v: any) => {
            return v.osName;
          })
        );
        if (res.length) {
          setSeriesList(
            res.map((v) => {
              return {
                name: v.areaName,
                type: "line",
                data: v.list,
              };
            })
          );
        } else {
          setSeriesList([]);
        }
      });
  }, [time, selectData, type]);

  useEffect(() => {
    return () => {
      setLegendList([]);
      setSeriesList([]);
    };
  }, [time]);

  return (
    <div className={styles.dataAnaylse}>
      <div className={styles.dataContent}>
        <Tabs
          defaultActiveKey={type}
          onChange={(key) => {
            // console.log(key)
            setType(key)
          }}
          style={{ height: '100%' }}
        >
          <TabPane tab='诊疗数' key='1' style={{ height: '100%' }}>
            <div className={styles.healthSelect}>
              <Button
                type='primary'
                onClick={() => setIsModalVisible(true)}
                style={{ margin: '10px' }}
              >
                选择卫健委(局)
              </Button>
              {selectData?.map((v: any) => {
                return (
                  <Tag
                    key={v.osId}
                    closable
                    color='processing'
                    onClose={() => {
                      setSelectData(
                        selectData.filter((item: any) => item.osId !== v.osId)
                      )
                    }}
                    style={{ margin: '10px' }}
                  >
                    {v.osName}
                  </Tag>
                )
              })}
            </div>
            {selectData.length ? (
              <DataAnaylseContent
                title='各卫健委(局)监管诊疗数据对比分析'
                time={time}
                setTime={(t: number) => {
                  setTime(t)
                }}
                legendList={legendList}
                seriesList={seriesList}
              />
            ) : (
              <Skeleton
                isSelect={() => {
                  setIsModalVisible(true)
                }}
              />
            )}
          </TabPane>
          <TabPane tab='预警数' key='2' style={{ height: '100%' }}>
            <div className={styles.healthSelect}>
              <Button
                type='primary'
                onClick={() => setIsModalVisible(true)}
                style={{ margin: '10px' }}
              >
                选择卫健委(局)
              </Button>
              {selectData?.map((v: any) => {
                return (
                  <Tag
                    key={v.osId}
                    closable
                    color='processing'
                    onClose={() => {
                      setSelectData(
                        selectData.filter((item: any) => item.osId !== v.osId)
                      )
                    }}
                    style={{ margin: '10px' }}
                  >
                    {v.osName}
                  </Tag>
                )
              })}
            </div>
            {selectData.length ? (
              <DataAnaylseContent
                title='各卫健委(局)监管预警数据对比分析'
                time={time}
                setTime={(t: number) => {
                  setTime(t)
                }}
                legendList={legendList}
                seriesList={seriesList}
              />
            ) : (
              <Skeleton
                isSelect={() => {
                  setIsModalVisible(true)
                }}
              />
            )}
          </TabPane>
          <TabPane tab='处置数' key='3' style={{ height: '100%' }}>
            <div className={styles.healthSelect}>
              <Button
                type='primary'
                onClick={() => setIsModalVisible(true)}
                style={{ margin: '10px' }}
              >
                选择卫健委(局)
              </Button>
              {selectData?.map((v: any) => {
                return (
                  <Tag
                    key={v.osId}
                    closable
                    color='processing'
                    onClose={() => {
                      setSelectData(
                        selectData.filter((item: any) => item.osId !== v.osId)
                      )
                    }}
                    style={{ margin: '10px' }}
                  >
                    {v.osName}
                  </Tag>
                )
              })}
            </div>
            {selectData.length ? (
              <DataAnaylseContent
                title='各卫健委(局)监管处置数据对比分析'
                time={time}
                setTime={(t: number) => {
                  setTime(t)
                }}
                legendList={legendList}
                seriesList={seriesList}
              />
            ) : (
              <Skeleton
                isSelect={() => {
                  setIsModalVisible(true)
                }}
              />
            )}
          </TabPane>
        </Tabs>
      </div>
      <SupervisorSelectModal
        visible={isModalVisible}
        initialValue={selectData}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => setIsModalVisible(false)}
        onChange={(s) => setSelectData(s)}
      />
    </div>
  )
};
